"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAddressMetadata = fetchAddressMetadata;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _models = require("../models");
async function fetchAddressMetadata(api, customerId) {
  const emptyAddressResponse = {};
  try {
    const response = await (0, _globalApiClientReact.getCustomerAddressesMetadata)(api, customerId);
    return new _models.FetchResult(response.status, response.data);
  } catch (error) {
    return _models.FetchResult.errorFor(emptyAddressResponse);
  }
}
//# sourceMappingURL=fetchAddressMetadata.js.map